import { render } from "./BalancesTable.vue?vue&type=template&id=4a581bd9"
import script from "./BalancesTable.vue?vue&type=script&lang=js"
export * from "./BalancesTable.vue?vue&type=script&lang=js"

import "./BalancesTable.vue?vue&type=style&index=0&id=4a581bd9&lang=css"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__